/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DebitoMesiPrecedenti } from './debito-mesi-precedenti';
import { Servizio } from './servizio';
import { Scuola } from './scuola';
import { Portafogli } from './portafogli';
import { Pagamenti } from './pagamenti';


export interface CittadinoMensaStudenteDTO { 
    id?: string;
    nome?: string;
    cognome?: string;
    scuola?: Scuola;
    is_sospeso?: boolean;
    is_esente?: boolean;
    servizio?: Servizio;
    portafogli?: Portafogli;
    pagamenti?: Pagamenti;
    debito_mesi_precedenti?: DebitoMesiPrecedenti;
}

